import { get, post } from "../GenericServices";

const ExpenseRefundApproval = {
  sendApproval: (data) => {
    return post(`expense-refund-approval/send-approval`, data);
  },
  waitingApproval: (queryString) => {
    return get(`expense-refund-approval/waiting-approval?${queryString}`);
  },
  getApproved: (queryString) => {
    return get(`expense-refund-approval/approved?${queryString}`);
  },
  confirmApproval: (data) => {
    return post(`expense-refund-approval/confirm`, data);
  },
  expenseRefundExportApproval: () => {
    return get(`expense-refund-approval/export`, {}, "blob");
  },
  getAlreadyApproved: (filters) => {
    return get(`expense-refund-approval/already-approved?${filters}`);
  },
};

export default ExpenseRefundApproval;
